import { Button, type ButtonProps, type FormInstance } from 'antd';
import type { PropsWithChildren } from 'react';

import { useFormValidation } from '@/hooks/use-form-validation';

interface SubmitButtonProps extends Omit<ButtonProps, 'form'> {
  form: FormInstance;
  regexPatternsForRequiredPair?: string[];
}

export function SubmitButton({
  form,
  children,
  disabled,
  regexPatternsForRequiredPair,
  ...rest
}: PropsWithChildren<SubmitButtonProps>) {
  const { submittable } = useFormValidation({
    form,
    regexPatternsForRequiredPair,
  });

  return (
    <Button
      block
      type="primary"
      htmlType="submit"
      disabled={!submittable || disabled}
      {...rest}
    >
      {children}
    </Button>
  );
}
